import { Component, OnInit, Input } from '@angular/core';

import {RootScopeDeclare} from '../../core/rootscope-declare';
import {RootScopeService} from '../../core/shared-service/root-scope.service';
import {Observable, Subscription } from 'rxjs';
import { FacilityObject } from '../../core/services/facility.model';
import { FacilityService } from '../../core/services/facility.service';
import { BreadcrumbService } from '../services/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {

  @Input() breadCrumbDataList: any;
  rootScopeData: RootScopeDeclare;
  routeData$ : Observable<any>;
  currentFacility: FacilityObject;
  private _facilityOnChange: Subscription;

  constructor(private rootScopeService: RootScopeService, private _facilityService: FacilityService, private breadcrumbService: BreadcrumbService) {
    this.getRootScopeData();   
  }

  ngOnInit() {
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
    });
  }

  ngOnDestroy(){
    this._facilityOnChange.unsubscribe();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  tryToMoveAwayFromCurrentPage(path: string): boolean {
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.showUnSavedChangesModal = true;
      this.rootScopeData.pathToNavigate = path;
      return false;
    }
    return true;
  }

}